// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class KycResponse extends APIModel {
    isNameRequired: boolean;
    isBirthnumberRequired: boolean;
    isBirthDateRequired: boolean;
    isSexRequired: boolean;
    isPermanentResidenceRequired: boolean;
    isCitizenshipRequired: boolean;
    isPhoneNumberRequired: boolean;
    isIsPoliticallyExposedPersonRequired: boolean;

    constructor(options?: APIModelOptions) {
        super(KycResponse.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "isNameRequired", type: "boolean" },
            { name: "isBirthnumberRequired", type: "boolean" },
            { name: "isBirthDateRequired", type: "boolean" },
            { name: "isSexRequired", type: "boolean" },
            { name: "isPermanentResidenceRequired", type: "boolean" },
            { name: "isCitizenshipRequired", type: "boolean" },
            { name: "isPhoneNumberRequired", type: "boolean" },
            { name: "isIsPoliticallyExposedPersonRequired", type: "boolean" }
        ];
    }
}




